import { http } from '@/repositories/http'
import { CompanyRepository, CompanyRepositoryImpl } from '@/repositories/system/companyRepository'
import { UserRepository, UserRepositoryImpl } from '@/repositories/system/userRepository'
import { NoticeRepository, NoticeRepositoryImpl } from '@/repositories/system/noticeRepository'

type Repositories = {
  company: CompanyRepository;
  user: UserRepository;
  notice: NoticeRepository
}

export const repositories: Repositories = {
  company: new CompanyRepositoryImpl(http),
  user: new UserRepositoryImpl(http),
  notice: new NoticeRepositoryImpl(http)
}
